import { useEffect } from "react";
import { useReducedMotion } from "framer-motion";

// Keeps the subtle sensor/parallax response without replacing the browser cursor.
// The previous custom cursor ring made normal mouse use and scrolling feel obstructed.
export default function InteractionLayer() {
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce || window.matchMedia("(pointer: coarse)").matches) return undefined;

    const onMove = (event) => {
      const nx = ((event.clientX / window.innerWidth) - 0.5) * 2;
      const ny = ((event.clientY / window.innerHeight) - 0.5) * 2;
      const root = document.documentElement.style;
      root.setProperty("--sensor-x", `${nx * 22}px`);
      root.setProperty("--sensor-y", `${ny * 16}px`);
      root.setProperty("--sensor-x-sm", `${nx * 5}px`);
      root.setProperty("--sensor-y-sm", `${ny * 4}px`);
      root.setProperty("--sensor-x-md", `${nx * 9}px`);
      root.setProperty("--sensor-y-md", `${ny * 7}px`);
      root.setProperty("--sensor-x-inv", `${nx * -10}px`);
      root.setProperty("--sensor-y-inv", `${ny * -8}px`);
      root.setProperty("--sensor-x-inv-sm", `${nx * -5}px`);
      root.setProperty("--sensor-y-inv-sm", `${ny * -4}px`);
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, [reduce]);

  return null;
}
